import React from "react";

export const Water = () => (
  <svg viewBox="0 0 512 512" width="512px" height="512px">
    <path
      d="M120.37,366.64c0.55-20.22,9.97-49.62,18.96-79c28.32-92.61,63.35-182.8,98.95-272.79
		c3.31-8.35,8-14.62,17.48-14.84c8.9-0.21,14.3,5.17,17.4,13.15c41.04,105.45,82.74,210.6,112.5,320.08
		c23.67,87.07-27.06,150.38-82.88,170.58C214.49,535.78,120.36,470.81,120.37,366.64z"
    />
  </svg>
);
